import { blinkTitle, resetTitle } from "../../services/helpers/update-title";
import getWordEnding from "../../services/helpers/get-word-ending";

const updateNotificationsCount = (count) => {
  count = parseInt(count) || 0;

  let counters = Array.from(document.querySelectorAll('[data-notifications-marker]'));
  counters.forEach(counter => counter.classList.toggle('has-new', count > 0));

  if (count > 0) {
    blinkTitle(`${count} ${getWordEnding(count, ['новое уведомление', 'новых уведомления', 'новых уведомлений'])}`);
  } else {
    resetTitle();
  }
}

export { updateNotificationsCount };